import { set, toggle } from '@/utils/vuex'

export default {
  setContestList (state, data) {
    state.contestList = data
  },
  setContestDetails (state, data) {
    state.contestDetails = data
  }
}
